<template>
  <div>
    <v-menu offset-y top content-class="elevation-4" :close-on-content-click="false" v-model="menu_opened">
      <template v-slot:activator="{on, attrs}">
        <v-text-field
            readonly
            class="rounded_8px height_56px"
            outlined
            placeholder="Gimme days, times"
            v-bind="attrs"
            v-on="on"
            v-model="form_weekdays_field_text"
        />
      </template>
      <div>
        <v-card max-width="360px" min-height="280px" style="display: flex; align-items: center">
          <v-card-text>
            <v-virtual-scroll :items="weekdays" height="150px" item-height="30">
              <template v-slot="{ item }">
                <v-list-item>
                  <v-list-item-title>
                    <v-checkbox
                        multiple
                        :readonly="watch_only"
                        style="margin: 5px 10px 5px 0;"
                        color="#207EA9"
                        :label="$i18n.t(`days_of_week.${item}`)"
                        :value="item"
                        v-model="selected_settings.selected_weekdays"
                    />
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-virtual-scroll>
            <div style="display: flex; justify-content: space-between; margin-top: 15px">
              <time-picker
                :disabled="watch_only"
                style="width: 48%; height: 56px"
                :time="minutes_to_time(selected_settings.start_time_in_mins)"
                :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                :width="'220px'"
                @save_time="(params) => {selected_settings.start_time_in_mins = this.get_time_in_minutes(params.time)}"
              />
              <time-picker
                  :disabled="watch_only"
                  style="width: 48%; height: 56px"
                  :time="minutes_to_time(selected_settings.end_time_in_mins)"
                  :placeholder="$i18n.t('pages.vehicles_lists.dialog.time')"
                  :width="'220px'"
                  @save_time="(params) => {selected_settings.end_time_in_mins = this.get_time_in_minutes(params.time)}"
              />
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-menu>
  </div>
</template>

<script>
import {i18n} from "@/i18n";
import TimePicker from "@/custom_components/TimePicker";

export default {
  name: "WeekDaysAndTimePicker",
  components: {TimePicker},
  props: [
      'watch_only',
      'selected_weekdays_prop',
      'start_time_in_mins_prop',
      'end_time_in_mins_prop'
  ],
  data () {
    return {
      menu_opened: false,
      weekdays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      previous_settings: {},
      // selected_settings: this.selected_settings_prop,
      selected_settings: {
          selected_weekdays: this.selected_weekdays_prop,
          start_time_in_mins: this.start_time_in_mins_prop,
          end_time_in_mins: this.end_time_in_mins_prop,
      },
    }
  },
  methods: {
    minutes_to_time: function (minutes) {
        let hours = parseInt(minutes / 60)
        hours = hours > 10 ? hours : `0${hours}`
        minutes = minutes % 60
        minutes = minutes >= 10 ? minutes : `0${minutes}`
        return `${hours}:${minutes}`
    },
    get_time_in_minutes: function (time_str) {
        const [hours, minutes] = time_str.split(':')
        return parseInt(hours) * 60 + parseInt(minutes)
    },
    emit_change: function () {
      this.$emit(
          'change',
          this.selected_settings
      )
    }
  },
  computed: {
    form_weekdays_field_text: function () {
      if (!this.selected_settings) return 'PH: Загрузка...'
      let selected_weekdays = []
      for (let weekday of this.selected_settings.selected_weekdays) {
        let index_of_weekday = this.weekdays.indexOf(weekday)
        selected_weekdays.splice(index_of_weekday, 0, i18n.t(`days_of_week_short.${weekday}`))
      }
      selected_weekdays = selected_weekdays.join(', ')
      if (selected_weekdays) selected_weekdays = selected_weekdays + '; '
      let selected_settings_start_time = this.minutes_to_time(this.selected_settings.start_time_in_mins)
      let selected_settings_finish_time = this.minutes_to_time(this.selected_settings.end_time_in_mins)
      let text_from_time_to_time = i18n.t('pages.vehicles_lists.dialog.from_time_to_time',
                                    {time_from: selected_settings_start_time, time_to: selected_settings_finish_time})
      return `${selected_weekdays} ${text_from_time_to_time}`
    },
  },
  watch: {
    menu_opened (val) {
      if (val === true) Object.assign(this.previous_settings, this.selected_settings)
      if (val === false && (JSON.stringify(this.selected_settings) !== JSON.stringify(this.previous_settings))) {
        this.emit_change()
      }
    }
  }
}
</script>

<style scoped>

</style>